import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { createSelectors } from '~/shared/lib/zustand-utils'
import { RELEASE_NOTES_STORAGE_KEY } from '../config'

interface ReleaseNotesStore {
  isPopupOpen: boolean
  setIsPopupOpen: (isPopupOpen: boolean) => void
}

const releaseNotesStore = createSelectors(
  create<ReleaseNotesStore>((set) => ({
    isPopupOpen: false,
    setIsPopupOpen: (isPopupOpen: boolean) => set({ isPopupOpen }),
  })),
)

interface ReleaseNotesLocalStorageStore {
  lastReadReleaseNoteVersion: string | null
  setLastReadReleaseNoteVersion: (lastReadReleaseNoteVersion: string | null) => void
  lastDismissedReleaseNoteVersion: string | null
  setLastDismissedReleaseNoteVersion: (lastDismissedReleaseNoteVersion: string | null) => void
}

const releaseNotesLocalStorageStore = createSelectors(
  create<ReleaseNotesLocalStorageStore>()(
    persist(
      (set) => ({
        lastReadReleaseNoteVersion: null,
        setLastReadReleaseNoteVersion: (lastReadReleaseNoteVersion: string | null) =>
          set({ lastReadReleaseNoteVersion }),
        lastDismissedReleaseNoteVersion: null,
        setLastDismissedReleaseNoteVersion: (lastDismissedReleaseNoteVersion: string | null) =>
          set({ lastDismissedReleaseNoteVersion }),
      }),
      { name: RELEASE_NOTES_STORAGE_KEY },
    ),
  ),
)

export const useReleaseNotesSelectors = () => {
  const isPopupOpen = releaseNotesStore.use.isPopupOpen()
  const setIsPopupOpen = releaseNotesStore.use.setIsPopupOpen()
  const lastReadReleaseNoteVersion = releaseNotesLocalStorageStore.use.lastReadReleaseNoteVersion()
  const setLastReadReleaseNoteVersion =
    releaseNotesLocalStorageStore.use.setLastReadReleaseNoteVersion()
  const lastDismissedReleaseNoteVersion =
    releaseNotesLocalStorageStore.use.lastDismissedReleaseNoteVersion()
  const setLastDismissedReleaseNoteVersion =
    releaseNotesLocalStorageStore.use.setLastDismissedReleaseNoteVersion()
  return {
    isPopupOpen,
    setIsPopupOpen,
    lastReadReleaseNoteVersion,
    setLastReadReleaseNoteVersion,
    lastDismissedReleaseNoteVersion,
    setLastDismissedReleaseNoteVersion,
  }
}
